import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { PrintKind } from "@redotech/redo-fulfillment-group-common/fulfillment-print-status";
import { SortDirection } from "@redotech/redo-views-common/table";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { IsPrintedCell } from "../cells/is-printed-cell";

export const printKindToTitle = {
  [PrintKind.PICK_LIST]: "Pick list",
  [PrintKind.PACKING_SLIP]: "Packing slip",
  [PrintKind.LABEL]: "Label",
  [PrintKind.COMMERCIAL_INVOICE]: "Label",
  [PrintKind.PERSONALIZED_SLIP]: "Personalized insert",
  [PrintKind.RETURN_LABEL]: "Return label",
  [PrintKind.LOCAL_PICK_UP_LABEL]: "Local pick up label",
  [PrintKind.BILL_OF_LADING]: "Bill of lading",
  [PrintKind.PARCEL_PACKING_SLIP]: "Package packing slip",
  [PrintKind.ORDER_SUMMARY]: "Order summary",
};

const printKindToKey = {
  [PrintKind.PICK_LIST]: "pick-list",
  [PrintKind.PACKING_SLIP]: "packing-slip",
  [PrintKind.LABEL]: "label",
  [PrintKind.COMMERCIAL_INVOICE]: "commercial-invoice",
  [PrintKind.PERSONALIZED_SLIP]: "personalized-slip",
  [PrintKind.RETURN_LABEL]: "return-label",
  [PrintKind.LOCAL_PICK_UP_LABEL]: "local-pick-up-label",
  [PrintKind.BILL_OF_LADING]: "bill-of-lading",
  [PrintKind.PARCEL_PACKING_SLIP]: "parcel-packing-slip",
  [PrintKind.ORDER_SUMMARY]: "order-summary",
};

export const isPrintedColumn = function isPrintedColumn(
  kind: PrintKind,
): Column2<FulfillmentGroupData> {
  return {
    key: `is-${printKindToKey[kind]}-printed`,
    title: `${printKindToTitle[kind]} printed`,
    alignment: ColumnAlignment.LEFT,
    renderNormalCell: ({ row }) => {
      return <IsPrintedCell kind={kind} row={row} />;
    },
    width: 120,
    sort: SortDirection.ASC,
  };
};
